import { CookiesHelper } from "./cookies.helper";

interface IValidationRes {
    result: boolean;
    reason: string;
};
class AuthHelper {
    private processTokenValidation = (token: string | null): IValidationRes => {
        if (!token) {
            return { result: false, reason: 'not_found' };
        };

        try {
            const tokenPayload = JSON.parse(atob(token.split('.')[1]));
            const tokenExp = tokenPayload.exp;
            const dateNow = new Date();

            if (tokenExp < dateNow.getTime() / 1000) {
                return { result: false, reason: 'expired' };
            } else {
                return { result: true, reason: 'valid' };
            };
        } catch (e) {
            return { result: false, reason: 'invalid' };
        };
    };

    isSessionTokenValid = (): IValidationRes => {
        const sessionToken = CookiesHelper.get(`${process.env.REACT_APP__SESSION_TOKEN_NAME}`);
        return this.processTokenValidation(sessionToken);
    };

    isAuthTokenValid = (): IValidationRes => {
        const authToken = CookiesHelper.get(`${process.env.REACT_APP__AUTH_TOKEN_NAME}`);
        return this.processTokenValidation(authToken);
    };
};

const authHelper = new AuthHelper();
export { authHelper as AuthHelper };